/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.dashboard

import kotlinx.serialization.Serializable

@Serializable
data class DashboardSummary(
    val month: String,
    val totalCollectedThisMonth: Long,
    val totalOutstanding: Long,
    val overdueCount: Int,
    val pendingCount: Int,
    val paidCount: Int,
    val patients: List<PatientPaymentSummary>,
)
